import React, { useState, useEffect, useRef } from 'react'
import { useHistory, Link, useParams } from 'react-router-dom'
import { connect } from 'react-redux'
import { Switch, Space, Pagination, Spin, Skeleton } from 'antd'
import ReactTable from "react-table";
import "react-table/react-table.css";
import { OutlinedButton, FilledBrightButton } from '@oneblinktech-org/helios-base'
import {
    getUserTypes,
    getUserRoles,
    resetUserPassword,
    updateUserInOrg
} from '../../store/user/actions'
import $ from 'jquery';
import { displayShortName } from '../../helpers/globals';
import { plus } from '../../fakeData/svgFiles';
import AutoSelectOnTab from '../AutoSelectOnTab';
import Can from "../../components/Can";
import { PERMISSIONS } from "../../constants/permissions";
import Editable from '../Editable';
import _set from 'lodash/set';

const DEFAULT_PAGE_SIZE = 20

const customStyles = {
    headCells: {
        style: {
            paddingLeft: '2px',
            paddingRight: '2px',
        },
    },
    cells: {
        style: {
            paddingLeft: '2px',
            paddingRight: '2px',
        },
    },
}


const ExpandableTable = (props) => {
    const history = useHistory()

    const [data, setData] = useState([])
    const [currentPage, setCurrentPage] = useState(1)
    const [aUserExpanded, setAUserExpanded] = useState({})
    const [inactiveUser, setInactiveUser] = useState(false)
    const [users, setUsers] = useState([])

    const [focusField, setFocusField] = useState('')
    const [user, setUser] = useState({})
    const [changed, setChanged] = useState(false)
    const latestUserRef = useRef({})
    const updateTimeoutRef = useRef(null)

    const getRowTabIndex = (rowId, fieldOffset) => {
        const rowIndex = data.findIndex((item) => item.id === rowId)

        if (rowIndex === -1) return 0

        return (rowIndex * 4) + fieldOffset
    }

    const columns = [
        {
            Header: "Name",
            id: "lastName",
            accessor: row =>
                <div className="d-flex flex-row align-items-center user-edit content">
                    <div className='text-uppercase user_avatar'>
                        {displayShortName(row)}
                    </div>
                    <div className='edit-wrap' onClick={() => handleFocusField(row, 'name')} onFocus={() => handleFocusField(row, 'name')}>
                        <Editable
                            labelClassName={`name ${!row.is_active ? 'inactive' : ''}`}
                            defaultValue={row.firstname + ' ' + row.lastname}
                            focusField={focusField === 'name' && user.id === row.id}
                            onKeyDown={(e) => focusOutOnEnter(e.code, e.target.value, 'name', 'firstname', row.firstname + ' ' + row.lastname ?? '')}
                            onBlur={(e) => focusOutOnEnter(e.type, e.target.value, 'name', 'firstname', row.firstname + ' ' + row.lastname ?? '')}
                            autoFocus={focusField === 'name'}
                            tabIndex={getRowTabIndex(row.id, 1)}
                            size={'100px'}
                        />
                    </div>
                </div>
        },
        {
            Header: "Email",
            id: "email",
            accessor: row =>
                <div className='d-flex flex-row align-items-center user-edit content'>
                    <div className='edit-wrap' onClick={() => handleFocusField(row, 'email')} onFocus={() => handleFocusField(row, 'email')}>
                        <Editable
                            labelClassName={`user-text ${!row.is_active ? 'inactive' : ''}`}
                            type='text'
                            defaultValue={row.email}
                            focusField={focusField === 'email' && user.id === row.id}
                            onKeyDown={(e) => focusOutOnEnter(e.code, e.target.value, 'email', 'email', row.email ?? '')}
                            onBlur={(e) => focusOutOnEnter(e.type, e.target.value, 'email', 'email', row.email ?? '')}
                            autoFocus={focusField === 'email'}
                            tabIndex={getRowTabIndex(row.id, 2)}
                            size={'auto'}
                        />
                    </div>
                </div>
        },
        {
            Header: "Role",
            id: "userType",
            accessor: row =>
                <div className='edit-wrap' onClick={() => handleFocusField(row, 'role')} onFocus={() => handleFocusField(row, 'role')}>
                    <Editable
                        labelClassName={`user-text ${!row.is_active ? 'inactive' : ''}`}
                        type='select'
                        defaultValue={focusField === 'role' && user.id === row.id ? row.role_id : row.role}
                        focusField={focusField === 'role' && user.id === row.id}
                        onChange={(value) => {
                            const selectedRole = roleOptions?.find((i) => String(i.value) === String(value))?.label;

                            setUser((prev) => ({
                                ...(prev?.id === row.id ? prev : row),
                                role_id: value,
                                role: selectedRole ?? row.role,
                            }));

                            if (row.id)
                                setChanged(true)
                        }}
                        options={roleOptions}
                        disabled={row.role_id === 5 && row.role === 'Owner'}
                        autoFocus={focusField === 'role'}
                        tabIndex={getRowTabIndex(row.id, 3)}
                        size={'auto'}
                    />
                </div>
        },
        {
            Header: "Status",
            id: "is_active",
            accessor: row =>
                <div className='edit-wrap' >
                    <Switch
                        onChange={(checked) => onUserActive(checked, row)}
                        checked={!!row.is_active}
                        autoFocus
                        tabIndex={getRowTabIndex(row.id, 4)}
                    />
                </div>
        },
        {
            Header: "Action",
            id: 'action',
            accessor: row =>
                <OutlinedButton title='Send Password Reset' className='resetpass' clickEvent={() => props.resetUserPassword(row.id)} />
        },
    ]

    useEffect(() => {
        props.getUserTypes()
    }, [])

    useEffect(() => {
        props.getUserRoles()
    }, [])

    useEffect(() => {
        if (props.data.length > 0) {
            const data = props.data.filter(i => i.role !== 'Customer')
            if (inactiveUser) {
                setData(data.filter(item => !item.is_active))
                setUsers(data.filter(item => !item.is_active))
            }
            else {
                setData(data.filter(item => item.is_active))
                setUsers(data.filter(item => item.is_active))
            }
        }
    }, [props.data])

    useEffect(() => {
        const updateRecord = async () => {
            if (props.isSuccessOrgUserUpdate) {
                const temp = data
                await temp.map(item => {
                    if (item.id === props.updatedUser.id) {
                        return props.updatedUser
                    } else
                        return item
                })
                if (inactiveUser) {
                    $(`#rowId_${props.updatedUser.id}`).fadeOut("slow", async function () {
                        setAUserExpanded({})
                        setData(temp.filter(item => !item.is_active))
                    })
                } else {
                    $(`#rowId_${props.updatedUser.id}`).fadeOut("slow", async function () {
                        setAUserExpanded({})
                        setData(temp.filter(item => item.is_active))
                    });
                }

                props.SetUsersInOrg((prev) => ([...prev?.map((i) => i.id === props.updatedUser.id ? props.updatedUser : i)]))
            } else if (props.isSuccessOrgUserUpdate === false) {
                const users = await props.data.filter(i => i.role !== 'Customer')
                if (inactiveUser) {
                    setData(users.filter(item => !item.is_active))
                    setUsers(users.filter(item => !item.is_active))
                }
                else {
                    setData(users.filter(item => item.is_active))
                    setUsers(users.filter(item => item.is_active))
                }
                props.SetUsersInOrg((prev) => ([...prev?.map((i) => i.id === props.updatedUser.id ? props.updatedUser : i)]))
            }
        }
        updateRecord()
    }, [props.isSuccessOrgUserUpdate, props.updatedUser])

    const onTableChange = (pagination, filters, sorter, extra) => {

    }
    const onPagiChange = (pageNum) => {
        setCurrentPage(pageNum)
        props.getData(pageNum - 1)
    }

    const onSwitch = async (checked) => {
        setInactiveUser(checked)

        if (checked) {
            let copyData = await props.data.filter(item => item.is_active === false)
            setData(copyData)
        } else {
            let copyData = await props.data.filter(item => item.is_active === true)
            setData(copyData)
        }
    }

    const onUserActive = (checked, row) => {
        if (!checked && !window.confirm("Are you sure?")) return

        setUser((prev) => ({
            ...(prev?.id === row.id ? prev : row),
            is_active: checked
        }))
        setChanged(true)
    }

    const handleNewUser = (e) => {
        props.setNewUser({
            ...props.newUser,
            [e.target.name]: e.target.value
        })
    }


    useEffect(() => {
        latestUserRef.current = user
    }, [user])

    useEffect(() => {
        if (!changed || !latestUserRef.current?.id) return

        if (updateTimeoutRef.current) {
            clearTimeout(updateTimeoutRef.current)
        }

        updateTimeoutRef.current = setTimeout(() => {
            const payload = latestUserRef.current
            setData(data?.map((i) => i.id === user.id ? { ...i, ...user } : i))
            props.updateUserInOrg(payload)
            setChanged(false)
            setFocusField('')
        }, 100)

        return () => {
            if (updateTimeoutRef.current) {
                clearTimeout(updateTimeoutRef.current)
            }
        }
    }, [changed, user, props.updateUserInOrg])

    const handleFocusField = (selectedUser, field) => {
        setUser((prev) => (prev?.id === selectedUser?.id ? prev : selectedUser))
        setFocusField(field)
    }

    const focusOutOnEnter = (key, value, field, mainFieldPath, defaultValue) => {

        if (key === 'Enter' || key === 'Tab' || key === 'blur') {
            if (value !== defaultValue) {
                if (field === 'name') {
                    const name = value?.split(' ')
                    setUser((prev) => {
                        const newData = { ...prev, firstname: name[0] ?? '', lastname: name[1] ?? '' };
                        if (mainFieldPath) {
                            _set(newData, mainFieldPath, name[0] ?? '');
                            _set(newData, 'lastname', name[1] ?? '');
                        }
                        return newData;
                    })
                } else {
                    setUser((prev) => {
                        const newData = { ...prev, [field]: value };
                        if (mainFieldPath)
                            _set(newData, mainFieldPath, value);
                        return newData;
                    })
                }
                if (user?.id) {
                    setChanged(true)
                }
            }
        }
        if (key === 'Enter')
            setFocusField('')
        if (focusField === 'status' && key === 'Tab')
            setTimeout(() => setFocusField(''), 0);
    }

    const roleOptions = Object.entries(props.roles || {}).map(([key, role]) => ({
        key,
        label: role.name,
        value: role.id,
    }));

    return (
        <div>
            <div className="d-flex flex-column flex-md-row justify-content-end align-items-center mb-4">
                <div className="d-flex flex-row align-items-center col-12 col-xl-5">
                    <label className="table-toggle-text my-0 mr-2 ml-auto">Show {props.toggleTxt}</label>
                    <Switch onChange={onSwitch} />
                    <div>
                        <OutlinedButton
                            svgFile={plus}
                            title="Add New User"
                            clickEvent={(e) => {
                                props.setUserFToogle(true)
                            }}
                            className="add-user-btn"
                        />
                    </div>
                    {
                        props.isExpert &&
                        <div className="pointer reload-btn" onClick={() => props.export()}>
                            <img className="ml-3 mr-2" src={require('../../assets/images/export.svg').default} alt="" />
                            <label className="uppercase m-0">Export</label>
                        </div>
                    }
                </div>
            </div>

            <div className='users-table'>
                {data.length === 0 && props.loadingData ?
                    <Skeleton active paragraph={{ rows: 10, width: '100%' }} />
                    : data.length > 0 ?
                        <ReactTable
                            data={data}
                            columns={columns}
                            expanded={aUserExpanded}
                            pageSize={data.length}
                            getTrProps={(state, rowInfo, column, instance) => {
                                return {
                                    onClick: e => {
                                        if (e.target.name == "edit-action") {
                                            const expandedT = { ...aUserExpanded };
                                            expandedT[rowInfo.viewIndex] = aUserExpanded[rowInfo.viewIndex] ? false : true;
                                            setAUserExpanded({ [rowInfo.viewIndex]: true });
                                        }
                                    },
                                    style: {
                                        animation: rowInfo?.viewIndex?.toString() === Object.keys(aUserExpanded)[0] ? 'fadeOut 0.3s' : 'fadeIn 0.3s ease-in-out',
                                        opacity: rowInfo?.viewIndex?.toString() === Object.keys(aUserExpanded)[0] ? 0 : 1,
                                        height: rowInfo?.viewIndex?.toString() === Object.keys(aUserExpanded)[0] ? 0 : 'auto',
                                    }
                                };
                            }}
                        />
                        : null
                }

                {
                    data.length > 0 && Math.ceil(data.total / DEFAULT_PAGE_SIZE) > 1 &&
                    <Space className="custom-table-pos d-flex flex-row justify-content-around py-2">
                        <OutlinedButton
                            title="First"
                            className="uppercase"
                            disabled={currentPage == 1 ? true : false}
                            clickEvent={(e) => onPagiChange(1)}
                        />
                        <Pagination current={currentPage} defaultPageSize={DEFAULT_PAGE_SIZE} total={data.total} onChange={onPagiChange} showSizeChanger={false} />
                        <OutlinedButton
                            title="Last"
                            className="uppercase"
                            disabled={currentPage == Math.ceil(data.total / DEFAULT_PAGE_SIZE) ? true : false}
                            clickEvent={(e) => onPagiChange(Math.ceil(data.total / DEFAULT_PAGE_SIZE))}
                        />
                    </Space>
                }

                {
                    props.userFToogle &&
                    <>
                        {
                            data.length == 0 &&
                            <div className="new-user_row d-flex flex-row content profile_temp-title">
                                <div className='edit-wrap title my-2'>
                                    Name
                                </div>
                                <div className='edit-wrap title my-2'>
                                    Email
                                </div>
                                <div className='edit-wrap m-auto title my-2'>
                                    Role
                                </div>
                                <div className='edit-wrap m-auto title my-2'>
                                    Status
                                </div>
                                <div className='edit-wrap title my-2'>
                                    Action
                                </div>
                            </div>
                        }

                        <div className="new-user_row d-flex flex-row content">
                            <div className='edit-wrap'>
                                <input
                                    type="text"
                                    name="name"
                                    id="name"
                                    autoComplete="name"
                                    vaule={props.newUser.name}
                                    onChange={handleNewUser}
                                />
                            </div>

                            <div className='edit-wrap'>
                                <input
                                    type="email"
                                    name="email"
                                    id="email"
                                    vaule={props.newUser.email}
                                    onChange={handleNewUser}
                                />
                            </div>

                            {/* ✅ Role dropdown (Create) */}
                            <div className='edit-wrap m-auto'>
                                <AutoSelectOnTab
                                    placeholder="Select role"
                                    value={props.newUser?.role_id}
                                    size="large"
                                    style={{ width: '100%' }}
                                    options={roleOptions.map((r) => ({
                                        label: r.label,
                                        value: r.value
                                    }))}
                                    onChange={(val) => {
                                        props.setNewUser({
                                            ...props.newUser,
                                            role_id: val
                                        })
                                    }}
                                />
                            </div>

                            <div className='edit-wrap m-auto mobile-status'>
                                <Switch
                                    name="is_active"
                                    id="is_active"
                                    onChange={(checked) => {
                                        props.setNewUser({
                                            ...props.newUser,
                                            ['is_active']: checked
                                        })
                                    }}
                                    defaultChecked={true}
                                    value={props.newUser.is_active}
                                />
                                <span className="table-toggle-text my-0 ml-2">{props.newUser.is_active ? 'Active' : 'Inactive'}</span>
                            </div>

                            <div className='edit-wrap'>
                                {props.saveLoading ?
                                    <Spin className='mt-2' />
                                    :
                                    <FilledBrightButton
                                        type="button"
                                        title="Save"
                                        clickEvent={() => props.addNewUserInOrg()}
                                        className="mt-2"
                                    />
                                }
                            </div>
                        </div>
                    </>
                }

                <Can permission={PERMISSIONS.SETTINGS_USER_CREATE}>
                    <div className="px-3">
                        <OutlinedButton
                            svgFile={plus}
                            title="Add New User"
                            clickEvent={(e) => {
                                props.setUserFToogle(true)
                            }}
                            className="mt-2"
                        />
                    </div>
                </Can>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        types: state.UserReducer.user_types.data,
        isSuccessOrgUserUpdate: state.UserReducer.isSuccessOrgUserUpdate,
        updatedUser: state.UserReducer.updatedUser,
        roles: state.UserReducer.user_roles.data
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getUserTypes: () => dispatch(getUserTypes()),
        getUserRoles: () => dispatch(getUserRoles()),
        updateUserInOrg: (data) => dispatch(updateUserInOrg(data)),
        resetUserPassword: (userId) => dispatch(resetUserPassword(userId))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ExpandableTable)
